import { render, staticRenderFns } from "./patient-relation.vue?vue&type=template&id=418cc2d7&scoped=true&"
import script from "./patient-relation.vue?vue&type=script&lang=js&"
export * from "./patient-relation.vue?vue&type=script&lang=js&"
import style0 from "./patient-relation.vue?vue&type=style&index=0&id=418cc2d7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418cc2d7",
  null
  
)

export default component.exports